import React from 'react';
import { REPORT } from '../print/PrintAtoms';

export interface KeyNumberItem {
  value: string;
  label: string;
  note?: string;
}

export const KeyNumbers: React.FC<{ items: KeyNumberItem[] }> = ({ items }) => (
  <div style={{ display: 'flex', gap: 0, marginBottom: '16px' }}>
    {items.map((item, i) => (
      <div key={i} style={{
        flex: 1, padding: '12px 14px', background: REPORT.surface,
        borderRight: i < items.length - 1 ? `1px solid ${REPORT.rule}` : 'none',
        borderRadius: i === 0 ? '6px 0 0 6px' : i === items.length - 1 ? '0 6px 6px 0' : undefined,
      }}>
        <div style={{ fontSize: '22px', fontWeight: 400, color: REPORT.heading, fontFamily: 'Georgia, serif', lineHeight: 1.1 }}>
          {item.value}
        </div>
        <div style={{
          fontSize: '9px', color: REPORT.secondary, textTransform: 'uppercase',
          letterSpacing: '0.08em', fontFamily: 'monospace', marginTop: '4px',
        }}>
          {item.label}
        </div>
        {item.note && (
          <div style={{ fontSize: '8.5px', color: REPORT.caution, marginTop: '3px', fontStyle: 'italic' }}>
            {item.note}
          </div>
        )}
      </div>
    ))}
  </div>
);
